// Email Service - Frontend service for sending emails
// Makes HTTP requests to the email server backend
// In production (Vercel), uses serverless functions at /api
// In development, uses proxy configured in package.json or direct URL
const EMAIL_SERVER_URL = process.env.REACT_APP_API_URL || '';

/**
 * Send 2FA code via email backend
 * @param {string} email - Recipient email address
 * @param {string} code - 6-digit verification code
 * @param {string} userName - User's full name
 * @param {string} clinicName - Clinic name
 * @returns {Promise<Object>} - Result object with success status
 */
export const send2FACode = async (email, code, userName, clinicName = 'VS Diamond Dental Clinic') => {
  try {
    const response = await fetch(`${EMAIL_SERVER_URL}/api/send-2fa-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        code,
        userName,
        clinicName
      })
    });

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.message || 'Failed to send email');
    }

    return result;
  } catch (error) {
    console.error('Error calling email service:', error);
    return { 
      success: false, 
      message: error.message || 'Failed to send email' 
    };
  }
};

/**
 * Verify email service is running
 * @returns {Promise<Object>} - Service status
 */
export const verifyEmailService = async () => {
  try {
    const response = await fetch(`${EMAIL_SERVER_URL}/api/health`);
    await response.json();
    
    if (response.ok) {
      return { 
        success: true, 
        message: 'Email service is running' 
      };
    } else {
      return { 
        success: false, 
        message: 'Email service is not responding' 
      };
    }
  } catch (error) {
    return { 
      success: false, 
      message: 'Email service is not running. Please start the email server.' 
    };
  }
};

